export function getView(value) {
  return value ? 'Enabled' : 'Disabled'
}
